const GCS_ORIGIN = "https://storage.googleapis.com";

/** Must match `VAULT_UPLOAD_PROXY_PREFIX` in `src/setupProxy.js`. */
const VAULT_UPLOAD_PROXY_PREFIX = "/__vault-upload";

/**
 * Dev-only: rewrite a presigned vault-upload URL to the same-origin dev-server
 * proxy path, so the byte PUT is not a cross-origin request and never triggers
 * the CORS preflight that the vault bucket currently fails.
 *
 * Returns the URL untouched in any non-development build, and for any URL that
 * is not a GCS upload URL — so this is inert in staging/production, where the
 * real fix (a bucket CORS policy) is still required. Path and query string are
 * preserved byte-for-byte: the V4 signature covers them.
 *
 * See `src/setupProxy.js` for the proxy and the full explanation.
 */
export const toLocalVaultUploadUrl = (uploadUrl: string): string => {
  if (process.env.NODE_ENV !== "development") {
    return uploadUrl;
  }

  if (!uploadUrl.startsWith(`${GCS_ORIGIN}/`)) {
    return uploadUrl;
  }

  return VAULT_UPLOAD_PROXY_PREFIX + uploadUrl.slice(GCS_ORIGIN.length);
};
